import React from "react";
import { object } from 'prop-types';
import PayOptions from "Molecules/PayOptions";
import PolicyPayOptions from 'Molecules/PolicyPayOptions';
const PaySelect = (props) => {

	const { entityContext, mode} = props || {};
	const { billingId, policyId } = entityContext || {};
 	const isBilling =mode === "billing" ||(!mode && Boolean(billingId && billingId.length === 13));
 	const isPolicy =mode === "policy" ||(!mode && Boolean(policyId && policyId.length === 10));

	const keepFocusInSelectModal = (e) => {

		//add this attribute after the first tab iteration of the payselect elements
		let svgEl = document.getElementById(`svg-id${props.index}`)
		svgEl.setAttribute("tabindex", "0");

		if (e.keyCode === 9) {
			let closeDiv = document.getElementById(`image-x-symbol${props.index}`);
			closeDiv.focus();
		}
	}
		return(
			<div className="PaySelect">
				<div className="dx-col">
					<div className="payselect-header-area">
						<div className="payselect-header">Select option</div>
						<div
							onClick={props.closeHandler}
							aria-label="Close"
							className="close x-symbol"
							>

							<div
								style={{
									width: "20px",
									height: "20px",
									marginTop: "-60px",
									position: "absolute",
									zIndex: "300"
								}}
							/>
						</div>
					</div>
					
						{isBilling ? (
							<PayOptions props={props} index={props.index}
							/>) : isPolicy ? (
							<PolicyPayOptions props={props} index={props.index} entityContext={props.entityContext} />) : null}
				
					<div className="button-area"
					 id="button-area"
					 onClick={props.closeHandler}
					 onKeyDown={keepFocusInSelectModal}
					 >
						<button className="primary" index="0" type="button" onClick={props.closeHandler} id="done-button">
							Done
						</button>
					</div>

				</div>
			</div>
		);

}

PayOptions.propTypes = {
  props: object
};
 
export default PaySelect;

 


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PaySelect/PaySelect.js